import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
    HttpXsrfTokenExtractor,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export const AuthRequestInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const tokenExtractor = inject(HttpXsrfTokenExtractor);
    const token = tokenExtractor.getToken();

    if (!request.headers.get('X-XSRF-TOKEN') && token) {
        request = request.clone({
            headers: request.headers.append('X-XSRF-TOKEN', token),
        });
    }

    return next(request);
};
